export interface AuthorizePinCodeSuccessResult {
  result: string;
}

export interface FailureResult {
  statusCode: number;
  message: string;
  error: string;
}

export interface PriceObject {
  unit?: string;
  discountFrom?: string;
  discountTo?: string;
  discountInclVat?: number;
  discountExclVat?: number;
  priceExclVat: number;
  priceInclVat: number;
  vatAmount: number;
  vatPercentage: number;
}

export interface ElectricityPrice {
  costType: string;
  duration: { from: string; to: string | null };
  elementName: string;
  price: PriceObject;
  signatureDate: string;
}

export type PriceKeys =
  | 'fee'
  | 'energy'
  | 'dayEnergy'
  | 'nightEnergy'
  | 'otherSeasonEnergy'
  | 'insuranceFee'
  | 'priceGuarantee'
  | 'winterDayEnergy';

export type PricesList = Partial<Record<PriceKeys, PriceObject>>;

export enum MonthlyFeeType {
  base = 'base',
  flat = 'flat',
  insurance = 'insurance',
  energy = 'energy',
}

export interface MonthlyFeePriceObject extends PriceObject {
  type: MonthlyFeeType;
}

export interface Addon {
  active: boolean;
  price: PricesList;
  productName: string;
  tariffId: string;
  tariffNo: number;
  vapType: string;
  templateId?: string | number;
  terminateTemplateNo?: string;
}

export interface Address {
  streetName: string;
  houseNumber: string;
  houseLetter?: string;
  residence?: string;
  zipCode: string;
  cityName: string;
  countryCode: string;
}

export enum CustomerType {
  PRIVATE = 'Private',
  BUSINESS = 'Business',
}

export interface ContractDetails {
  electricityPrice?: ElectricityPrice;
  baseFee: ElectricityPrice;
  duration: {
    from: Date | string;
    to?: Date | string;
  };
  contractNumber: string;
  contractCode: string | number;
  name: string | string[];
  email: string;
  address: Address;
  meteringPointNo: string;
  meteringPointId: string;
  customerId: string | number;
  productName: string;
  activeAddons: Addon[];
  inactiveAddons: Addon[];
  recommendedAddon?: Addon;
  sunny: boolean;
  invoiceYearly: 0 | 1 | 4 | 6 | 12;
  specialElectricityPrice: {
    [key: string]: PriceObject;
  };
  customerType: CustomerType;
}

export interface AdminCustomer {
  id: string;
  contractCode: string;
  contractNo: string;
  createdAt: string;
  customerId: string;
  magicLink: { id: string; createdAt: string };
  updatedAt: string;
  customerType?: 'B2B' | 'B2C';
  queued: boolean;
  queueDate?: string;
}

export interface AdminGetCustomersResponse {
  count: number;
  page: number;
  size: number;
  result: AdminCustomer[];
}

export interface AdminStatsObject {
  amount: string;
  date: string;
}
export interface AdminGetStatsResponse {
  customers: AdminStatsObject[];
  magicLinks: AdminStatsObject[];
}
